import { motion } from "framer-motion";
import { CheckCircle2, Car, CalendarDays, Clock, X } from "lucide-react";
import { formatDMY } from "@/lib/date";

const formatTime = (t) => (t ? t.slice(0, 5) : "");
const formatDate = (d) => formatDMY(d);

const Row = ({ icon: Icon, label, value, testId }) => (
  <div className="flex items-center justify-between border-b border-slate-100 py-3 last:border-0">
    <span className="flex items-center gap-2 text-sm font-medium text-[#64748B]">
      <Icon className="h-4 w-4 text-[#5C2D91]" />
      {label}
    </span>
    <span className="text-right text-sm font-semibold text-[#0F172A]" data-testid={testId}>
      {value}
    </span>
  </div>
);

export const ConfirmationPanel = ({ booking, onClose }) => {
  return (
    <motion.section
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.35 }}
      className="rounded-xl border border-emerald-200 bg-white p-6 text-center shadow-md sm:p-8"
      data-testid="confirmation-panel"
    >
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50">
        <CheckCircle2 className="h-9 w-9 text-emerald-500" />
      </div>
      <h2 className="font-heading text-2xl font-bold text-[#0F172A]">Booking Confirmed</h2>
      <p className="mt-1 text-sm text-[#64748B]">
        Your company vehicle has been reserved successfully.
      </p>

      <div className="my-6 border-y border-slate-100 py-4">
        <p className="text-xs font-medium uppercase tracking-wider text-[#64748B]">
          Booking reference
        </p>
        <p
          className="font-heading text-3xl font-bold tracking-wider text-[#5C2D91]"
          data-testid="confirmation-reference"
        >
          {booking.booking_ref}
        </p>
      </div>

      <div className="mx-auto max-w-sm text-left">
        <Row icon={Car} label="Vehicle" value={booking.vehicle} testId="confirmation-vehicle" />
        <Row icon={CalendarDays} label="Date" value={formatDate(booking.booking_date)} testId="confirmation-date" />
        <Row icon={Clock} label="Start time" value={formatTime(booking.start_time)} testId="confirmation-start" />
        <Row icon={Clock} label="Estimated return time" value={formatTime(booking.return_time)} testId="confirmation-return" />
      </div>

      <p className="mt-5 text-xs text-[#64748B]">
        A confirmation email has been sent to {booking.company_email}.
      </p>

      <button
        onClick={onClose}
        className="mt-6 flex w-full transform items-center justify-center gap-2 rounded-lg bg-[#0F172A] px-4 py-3.5 font-semibold text-white transition-all hover:bg-[#1e293b] active:scale-[0.98]"
        data-testid="close-confirmation-button"
      >
        <X className="h-5 w-5" /> Close
      </button>
    </motion.section>
  );
};
